// @flow
import * as React from 'react';
import {Separator} from '../Separator/Separator';
import {InlineCode} from '../InlineCode/InlineCode';

type CurrencySeparatorProps = {|
  currencies: Array<React.Node>,
|};

export const CurrencySeparator = ({currencies}: CurrencySeparatorProps) => (
  <Separator
    items={currencies || []}
    render={(item) => <InlineCode>{item}</InlineCode>}
  />
);
